import { Component, OnInit } from '@angular/core';
import { ModificationService } from '../modification.service';
import { Modification } from '../modification';
import { Router } from '@angular/router';
import { NotificationService } from '../../../shared/notification.service';

@Component({
  selector: 'app-modification-create',
  templateUrl: 'create.component.html',
})
export class ModificationCreateComponent implements OnInit {
  /**
   * Details of the modification being created.
   */
  public modification: Modification;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {ModificationService} modificationService
   * @param {NotificationService} notificationService
   * @param {Router} router
   */
  constructor(
    private modificationService: ModificationService,
    private notificationService: NotificationService,
    private router: Router,
  ) {
    this.modificationService.loading.subscribe(
      result => (this.isLoading = result),
    );
  }

  /**
   * Initialise the component, creating a new blank modification if required.
   */
  public ngOnInit(): void {
    if (!this.modification) {
      this.modification = new Modification();
    }
  }

  /**
   * Perform the create action which adds the new modification into the backend.
   */
  public create() {
    const createModification = this.modificationService
      .createModification(this.modification)
      .subscribe(
        (result: Modification) => {
          this.notificationService.success(
            `Modification Created`,
            `New modification ${result.name} has been created with ID of ${
              result.id
            }.`,
            5,
          );
          this.modification = new Modification();
          createModification.unsubscribe();
          this.router.navigate(['/modifications']);
        },
        err => {
          this.notificationService.error(
            `Could not create Modification`,
            err.error.message,
            10,
          );
        },
      );
  }
}
